<div
  class="flex flex-col gap-8"
  data-id="advanced-filter-people"
  *transloco="let t; scope: 'featureSearch'"
>
  <bd-dropdown
    data-id="people-filter-user-dropdown"
    [options]="userOptions()"
    [(singleSelection)]="selectedUser"
    [settings]="dropdownSettings()"
    (filter)="onFilterUsers($event)"
    (selectNode)="onSelectUser($event)"
    (unselectNode)="onUnselectUser()"
    [loading]="usersLoading()"
  >
  </bd-dropdown>
</div>
